export interface SearchableListItem {
  title?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  emailId?: string;
  username?: string;
}

/**
 * Case-insensitive match of a list-view search query against every text field
 * a user would reasonably search by (title/name, first/last/full name, email,
 * username) — not just the first one that happens to be set.
 */
export const matchesListSearch = (item: SearchableListItem, query: string): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const fullName = [item.firstName, item.lastName].filter(Boolean).join(' ');
  return [item.title, item.name, item.firstName, item.lastName, fullName, item.emailId, item.username]
    .filter((value): value is string => typeof value === 'string' && value.length > 0)
    .some((value) => value.toLowerCase().includes(q));
};
